<script lang="ts">
  import { Link } from '@athena-lib/Link';
  import type { PaymentProviderIcon } from './types';

  type Props = {
    paymentProviderIcons: PaymentProviderIcon[];
  };

  const { paymentProviderIcons }: Props = $props();
</script>

<div class="flex w-full flex-col items-center justify-center gap-8 bg-st-black py-8 text-st-white">
  <div class="flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
    {#each paymentProviderIcons as icon}
      <Link href={icon.link?.href}>
        <img src={icon.icon.url} alt={icon.icon.alt} />
      </Link>
    {/each}
  </div>
  <div class="text-center text-sm">&copy; StickerApp 2024</div>
</div>
